import { Form } from '@/shared/ui'

export const CashReceiptBusinessField = () => {
  return (
    <Form.Field name="businessIssuanceNumber">
      <Form.Label bold>휴대폰 번호 또는 사업자 등록번호</Form.Label>
      <Form.TextField
        type="number"
        placeholder="휴대폰 번호/사업자 등록번호를 입력해 주세요"
        fullWidth
      />
      <Form.Message />
    </Form.Field>
  )
}
